var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import RESTAdapter from '@ember-data/adapter/rest';
// NB: Importing from @square causes strange TypeScript linting errors.

import { inject as service } from '@ember/service';
import { LocalizedAdapterError, TooManyExportsError } from './errors/export-errors';
let Export = (_class = class Export extends RESTAdapter {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "namespace", 'v2/reports');
    _initializerDefineProperty(this, "marketToasts", _descriptor, this);
  }
  pathForType() {
    return 'exports';
  }
  retry(record) {
    const url = `${this.buildURL('reports/export', record.id)}/retry`;
    return this.ajax(url, 'POST').catch(e => {
      record.set('retryAdapterError', e);
    });
  }
  cancel(record) {
    const url = `${this.buildURL('reports/export', record.id)}/cancel`;
    return this.ajax(url, 'POST').catch(e => {
      record.set('adapterError', e);
    });
  }
  dismissToast(record) {
    if (record.toastId !== undefined) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.marketToasts.remove(record.toastId);
    }
  }

  /*
   * Handle some errors with a special error class.
   * Neptr returns 405s, 422s, and 429s with JSONAPI localized errors.
   *
   * Note: 422s must be intercepted here because Ember Data's default handling
   * converts them to InvalidError and won't parse the JSONAPI fields.
   */
  handleResponse(status, headers, payload, requestData) {
    switch (status) {
      case 405:
        return new LocalizedAdapterError(payload);
      case 422:
        return new LocalizedAdapterError(payload);
      case 429:
        return new TooManyExportsError(payload);
      default:
        return super.handleResponse(status, headers, payload, requestData);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Export as default };